import { Component, ViewChild, enableProdMode } from '@angular/core';

import { Events, ionicBootstrap, MenuController, Nav, Platform } from 'ionic-angular';
import { Splashscreen, StatusBar } from 'ionic-native';

import { AccountPage } from './pages/account/account';

import { Jobs } from './pages/jobs/jobs';

import { MyjobsPage } from './pages/myjobs/myjobs';

import { MybidsPage } from './pages/mybids/mybids';

import { MessagePage } from './pages/message/message';


import { Invoice } from './pages/invoice/invoice';
import { LoginPage } from './pages/login/login';
import { Splash } from './pages/splash-screen/splash-screen';
import { UserData } from './providers/user-data';
import { Location } from './providers/location/location';

enableProdMode();

interface PageObj {
  title: string;
  component: any;
  icon: string;
  index?: number;
}

@Component({
  templateUrl: 'build/app.html'
})
class Letpco {

  @ViewChild(Nav) nav: Nav;

  appPages: PageObj[] = [

    { title: 'Jobs in Bidding ', component: Jobs, icon: 'calendar' },
    { title: 'My Bids', component: MybidsPage, icon: 'list' },
    { title: 'My Jobs', component: MyjobsPage, icon: 'clipboard' },
    { title: 'My Invoice', component: Invoice, icon: 'cash' },
    { title: 'Message', component: MessagePage, icon: 'mail' },
    { title: 'Logout', component: LoginPage, icon: 'log-out' }

  ];


    rootPage: any;
    userlog: boolean = false;


  constructor(
    public events: Events,
    public userData: UserData,
    public menu: MenuController,
    platform: Platform,
  
    public loc: Location) {

this.user();

    // Call any initial plugins when ready
    platform.ready().then(() => {

      StatusBar.styleDefault();
    });



  }



user() {

this.userData.storage.get(this.userData.HAS_LOGGED_IN).then((value) => {


if(value === 'true') {

this.rootPage = Jobs;
 
    this.userlog = value;


} else {
  this.rootPage = Splash;
   this.loc.stopTracking();
}

   
    });





}






  openPage(page: PageObj) {

if (page.title === 'Logout') {
      // Give the menu time to close before changing to logged out
      setTimeout(() => {
        this.userData.logout();
      }, 1000);
    }

this.nav.setRoot(page.component);

  }




}


ionicBootstrap(Letpco, [UserData, Location], { });
